export default {
  namespaced: true,
  state: {
    columns: {},
    models: {},
    commissions: {},
    platforms: {}
  },
  getters: {
    getCommissions: state => state.commissions,
    getPlatforms: state => state.platforms,
    getColumns: state => state.columns,
    getModels: state => state.models
  },
  mutations: {
    setColumns: (state, columns) => {
      state.columns = columns
    },
    setModels: (state, models) => {
      state.models = models
    },
    setCommissions: (state, clientCommissions) => {
      Object.assign(state.commissions, clientCommissions)
    },
    setPlatforms: (state, clientPlatforms) => {
      Object.assign(state.platforms, clientPlatforms)
    }
  },
  actions: {
    setColumns({commit}, columns) {
      commit('setColumns', columns);
    },
    setModels({commit}, models) {
      commit('setModels', models);
    },
    setCommissions({commit}, clientCommissions) {
      commit('setCommissions', clientCommissions);
    },
    setPlatforms({commit}, clientPlatforms) {
      commit('setPlatforms', clientPlatforms);
    },
    initStore({commit}, data) {
      if (data !== undefined) {
        commit('setModels', data['models']);
      }
    }
  }
};
